import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { Controller } from '@homeleite/domain';
import type { ControllerView } from '../controller-home.component';

@Component({
    selector: 'homeleite-controller-page',
    templateUrl: './controller-page.component.html',
    styleUrls: ['./controller-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ControllerPageComponent {
    @Output() logoutClick = new EventEmitter<void>();

    controller: Controller;
    view: ControllerView = 'painel';
    readonly views: { id: ControllerView; label: string; icon: string }[] = [
        { id: 'painel', label: 'Painel / Início', icon: 'insights' },
        { id: 'vincular', label: 'Vincular Produtores', icon: 'group_add' },
        { id: 'historico', label: 'Histórico de Controles', icon: 'history' }
    ];

    get currentViewLabel(): string {
        return this.views.find((item) => item.id === this.view)?.label ?? '';
    }

    get controllerInitial(): string {
        return (this.controller?.name || '?').trim().charAt(0).toUpperCase();
    }
}
